
<main>
    <div class="profile-details">
        <div class="profile-form">
            <form [formGroup]="medicineReminderForm">
                <div class="row">
                    <div class="form-group col-md-6">
                        <mat-form-field class="example-full-width w-100" appearance="outline">
                            <input matInput [ngxMatTimepicker]="picker1" formControlName="start_time" #formContainer
                                placeholder="સમય">
                            <ngx-mat-timepicker-toggle matSuffix [for]="picker1"></ngx-mat-timepicker-toggle>
                            <ngx-mat-timepicker #picker1></ngx-mat-timepicker>
                        </mat-form-field>
                        <div *ngIf="submitted && f.start_time.errors" class="error-message">
                            <small *ngIf="f.start_time.errors?.required" class="text-danger">સમય
                                જરૂરી છે.</small>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <input type="text" class="form-control" placeholder="વર્ણન" formControlName="remarks" />
                    </div>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn-common" *ngIf="buttonclick == false"
                        (click)="addMedicineReminder()">નોંધણી
                        કરો</button>
                    <button type="submit" class="btn-common" *ngIf="buttonclick == true"
                        (click)="editMedicineReminder()">નોંધણી
                        કરો</button>
                </div>
            </form>
        </div>
    </div>
    <div class="jobs">
        <hr>
        <div>
            <div class="main-members">
                <a class="member-list-item" *ngFor="let data of medicineHistoryData">
                    <div class="flex1">
                        <h5>સમય : {{ data.start_time }}</h5>
                        <p>{{data.remarks}}</p>
                    </div>
                    <i class="ti ti-pencil" (click)="editMedicineData(data)"></i>
                    <mat-slide-toggle [(ngModel)]="data.is_active" class="example-margin"
                        [color]="data.is_active == 1? 'green' : 'red' " (change)="openDialog($event,data)">
                    </mat-slide-toggle>
                </a>
            </div>
        </div>
    </div>
</main>